import { CommandGetJob } from "./commands/cmdGetJob";
import { CommandGetJobLogs } from "./commands/cmdGetJobLogs";
import { CommandGetJobNetworkErrors } from "./commands/cmdGetJobNetworkErrors";
import { CommandListJobs } from "./commands/cmdListJobs";
import { CommandCreateJob } from "./commands/cmdCreateJob";
import { CommandRetryJob } from "./commands/cmdRetryJob";
import { CommandResumeJob } from "./commands/cmdResumeJob";
import { addJob } from "@store/jobTrackerStore";

export class JobService {
  async getJob(id: number) {
    const cmd = new CommandGetJob();
    const results = await cmd.run(id);
    return results;
  }

  async getJobLogs(id: number) {
    const cmd = new CommandGetJobLogs();
    return await cmd.run(id);
  }

  async getJobNetworkErrors(id: number) {
    const cmd = new CommandGetJobNetworkErrors();
    return await cmd.run(id);
  }

  async listJobs(
    limit: number,
    offset: number,
    opts: { types?: string[]; statuses?: string[]; search?: string; parentsOnly?: boolean } = {},
  ) {
    const cmd = new CommandListJobs();
    const results = await cmd.run(
      limit, offset, opts.types, opts.statuses, opts.search, opts.parentsOnly,
    );
    return results;
  }

  async createJob(payload: any) {
    const cmd = new CommandCreateJob();
    const results = await cmd.run({ execution_mode: "celery", ...payload });
    addJob(results);
    return results;
  }

  async retryJob(id: number) {
    const cmd = new CommandRetryJob();
    const results = await cmd.run(id)
    return results
  }

  async resumeJob(id: number) {
    return await new CommandResumeJob().run(id);
  }
}
